import React, { useEffect } from 'react';
import { Routes, Route, useLocation, BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import QuoteGenerator from './containers/QuoteGenerator';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import BookingJourney from './containers/BookingJourney';
import TermsConditions from './containers/TermsConditions';
import Payment from './containers/Payment';
import BookingSuccessfull from './containers/BookingSuccessfull';
import CustomDateTimePicker from './components/CustomDateTimePicker';
import ForgotPasswordContainer from './containers/ForgotPassword';
import GetQuote from './components/GetQuote/GetQuote';
import Footer from './containers/Footer';
import Header from './containers/Header';
import ResetPasswordContainer from './containers/ResetPassword';
import LoginContainer from './containers/LoginContainer';
// Google Tag manager
import TagManager from 'react-gtm-module';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux'; // Ensure you export 'persistor' from your store setup
import SystemSettingsLoader from './components/SystemSettingsLoader';


const tagManagerArgs = {
  gtmId: 'GTM-PC8TZH'
};

TagManager.initialize(tagManagerArgs);

// Initialize ReactGA outside of components
const TRACKING_ID = 'G-T60TERE6RT';
ReactGA.initialize(TRACKING_ID);

function usePageTracking() {
  let location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);
}

const theme = createTheme({
  typography: {
    fontFamily: '"Nexa", "Arial", sans-serif',
  },
});

function App() {
  usePageTracking();

  useEffect(() => {
    // Function to send height to parent
    const sendHeightToParent = () => {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ height }, '*');
    };

    // Call the function periodically (e.g., every second)
    const intervalId = setInterval(sendHeightToParent, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <SystemSettingsLoader />
      <Header />
      <Routes>
        <Route path="/" element={<QuoteGenerator />} />
        <Route path="/quote/:id" element={<GetQuote />} />
        <Route path="/booking" element={<BookingJourney />} />
        <Route path="/login/:id" element={<LoginContainer />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/success/:book" element={<BookingSuccessfull />} />
        <Route path="/check" element={<CustomDateTimePicker />} />
        <Route path="/forgot" element={<ForgotPasswordContainer />} />
        <Route path="/recovery/activkey/:activekey/basketId/:basketId" element={<ResetPasswordContainer />} />
      </Routes>
      <Footer />
    </>
  );
}

function WrappedApp() {
  return (
    <Provider store={store}>
      <PersistGate loading={<div>Loading persisted state...</div>} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default WrappedApp;

